export const AGENCY_TESDA_ID = 27;

export const AGENCY_TESDA =
  "Technical Education and Skills Development Authority";

export const AGENCY_DOH_ID = 8;

export const AGENCY_DOH_MAIP_ID = 6;

export const AGENCY_DSWD_ID = 16;

export const AGENCY_CHED_ID = 28;

export const AGENCY_DOLE_ID = 11;

export const AGENCY_DBM_ID = 3;

export const AGENCY_DPWH_ID = 14;

export const DBM_PROGRAM_LGSF_ID = 14;

export const TESDA_PROGRAM_STEP_ID = 10;

export const TESDA_PROGRAM_TWSP_ID = 15;

export const TESDA_PROGRAMS = [TESDA_PROGRAM_STEP_ID, TESDA_PROGRAM_TWSP_ID];

export const TESDA_COURSE_PROGRAMS = [
  {
    label: "STEP",
    value: TESDA_PROGRAM_STEP_ID,
  },
  {
    label: "TWSP",
    value: TESDA_PROGRAM_TWSP_ID,
  },
];

export const TESDA_PROGRAM_STEP_TOOLKIT_COST = 800;
